import { setStoreValue } from "@/store/utils";

export const SET_BOOKING_TEMPLATES = "SET_BOOKING_TEMPLATES";
export const SET_BOOKING_TEMPLATE = "SET_BOOKING_TEMPLATE";
export const SET_LOCATIONS = "SET_LOCATIONS";
export const SET_REASONS_FOR_HIRE = "SET_REASONS_FOR_HIRE";
export const SET_COST_CODES = "SET_COST_CODES";
export const SET_IS_FETCHING_DATA = "SET_IS_FETCHING_DATA";
export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_FIELD_NECESSITIES = "SET_FIELD_NECESSITIES";
export const SET_IS_FETCHING_FIELD_NECESSITIES =
  "SET_IS_FETCHING_FIELD_NECESSITIES";
export const SET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS =
  "SET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS";
export const SET_PUBLISHING_SCHEDULE_TAGS = "SET_PUBLISHING_SCHEDULE_TAGS";
export const SET_TAGS = "SET_TAGS";
export const SET_IS_FETCHING_TAGS = "SET_IS_FETCHING_TAGS";
export const SET_IS_FETCHING_COST_CATEGORIES =
  "SET_IS_FETCHING_COST_CATEGORIES";
export const SET_COST_CATEGORIES = "SET_COST_CATEGORIES";
export const SET_IS_FETCHING_SEXUAL_ORIENTATIONS =
  "SET_IS_FETCHING_SEXUAL_ORIENTATIONS";
export const SET_SEXUAL_ORIENTATIONS = "SET_SEXUAL_ORIENTATIONS";
export const SET_IS_FETCHING_RELIGIONS = "SET_IS_FETCHING_RELIGIONS";
export const SET_RELIGIONS = "SET_RELIGIONS";
export const SET_MARITAL_STATUSES = "SET_MARITAL_STATUSES";
export const SET_IS_FETCHING_MARITAL_STATUSES =
  "SET_IS_FETCHING_MARITAL_STATUSES";
export const SET_LOCATION_GROUPINGS = "SET_LOCATION_GROUPINGS";
export const SET_ETHNIC_GROUPS = "SET_ETHNIC_GROUPS";
export const SET_IS_FETCHING_GRADES = "SET_IS_FETCHING_GRADES";
export const SET_GRADES = "SET_GRADES";
export const SET_IS_FETCHING_WORKING_HOURS = "SET_IS_FETCHING_WORKING_HOURS";
export const SET_WORKING_HOURS = "SET_WORKING_HOURS";
export const SET_IS_FETCHING_FUNCTIONS = "SET_IS_FETCHING_FUNCTIONS";
export const SET_FUNCTIONS = "SET_FUNCTIONS";
export const SET_IS_FETCHING_CONTRACT_TYPES = "SET_IS_FETCHING_CONTRACT_TYPES";
export const SET_CONTRACT_TYPES = "SET_CONTRACT_TYPES";
export const SET_IS_FETCHING_WORKING_HOURS_GROUPINGS =
  "SET_IS_FETCHING_WORKING_HOURS_GROUPINGS";
export const SET_WORKING_HOURS_GROUPINGS = "SET_WORKING_HOURS_GROUPINGS";
export const SET_CONTRACT_TYPES_GROUPINGS = "SET_CONTRACT_TYPES_GROUPINGS";
export const SET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS =
  "SET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS";

const dataMutations = {
  [SET_BOOKING_TEMPLATES]: setStoreValue("bookingTemplates"),
  [SET_BOOKING_TEMPLATE]: setStoreValue("currentBookingTemplate"),
  [SET_LOCATIONS]: setStoreValue("locations"),
  [SET_REASONS_FOR_HIRE]: setStoreValue("reasonsForHire"),
  [SET_COST_CODES]: setStoreValue("costCodes"),
  [SET_IS_FETCHING_DATA]: setStoreValue("isFetchingData"),
  [SET_COUNTRIES]: setStoreValue("countries"),
  [SET_FIELD_NECESSITIES]: setStoreValue("fieldNecessities"),
  [SET_IS_FETCHING_FIELD_NECESSITIES]: setStoreValue(
    "isFetchingFieldNecessities"
  ),
  [SET_PUBLISHING_SCHEDULE_TAGS]: setStoreValue("publishingScheduleTags"),
  [SET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS]: setStoreValue(
    "isFetchingPublishingScheduleTags"
  ),
  [SET_TAGS]: setStoreValue("tags"),
  [SET_IS_FETCHING_TAGS]: setStoreValue("isFetchingTags"),
  [SET_IS_FETCHING_COST_CATEGORIES]: setStoreValue("isFetchingCostCategories"),
  [SET_COST_CATEGORIES]: setStoreValue("costCategories"),
  [SET_SEXUAL_ORIENTATIONS]: setStoreValue("sexualOrientations"),
  [SET_IS_FETCHING_SEXUAL_ORIENTATIONS]: setStoreValue(
    "isFetchingSexualOrientations"
  ),
  [SET_IS_FETCHING_RELIGIONS]: setStoreValue("isFetchingReligions"),
  [SET_RELIGIONS]: setStoreValue("religions"),
  [SET_MARITAL_STATUSES]: setStoreValue("maritalStatuses"),
  [SET_IS_FETCHING_MARITAL_STATUSES]: setStoreValue(
    "isFetchingMaritalStatuses"
  ),
  [SET_LOCATION_GROUPINGS]: setStoreValue("locationGroupings"),
  [SET_ETHNIC_GROUPS]: setStoreValue("ethnicGroups"),
  [SET_IS_FETCHING_GRADES]: setStoreValue("isFetchingGrades"),
  [SET_GRADES]: setStoreValue("grades"),
  [SET_IS_FETCHING_WORKING_HOURS]: setStoreValue("isFetchingWorkingHours"),
  [SET_IS_FETCHING_WORKING_HOURS_GROUPINGS]: setStoreValue(
    "isFetchingWorkingHoursGroupings"
  ),
  [SET_WORKING_HOURS]: setStoreValue("workingHours"),
  [SET_WORKING_HOURS_GROUPINGS]: setStoreValue("workingHoursGroupings"),
  [SET_FUNCTIONS]: setStoreValue("functions"),
  [SET_IS_FETCHING_FUNCTIONS]: setStoreValue("isFetchingFunctions"),
  [SET_CONTRACT_TYPES]: setStoreValue("contractTypes"),
  [SET_CONTRACT_TYPES_GROUPINGS]: setStoreValue("contractTypesGroupings"),
  [SET_IS_FETCHING_CONTRACT_TYPES]: setStoreValue("isFetchingContractTypes"),
  [SET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS]: setStoreValue(
    "isFetchingContractTypesGroupings"
  )
};

export default dataMutations;
